export default (entities, selected, entityIds) =>
	[...entities].map((entity) => {
		if (entityIds.some((id) => id === entity.entityId)) {
			return {...entity, contacts: entity.contacts?.filter((c) => !selected.some((s) => s === c.userId))};
		}
		return {...entity};
	});
